import { render, staticRenderFns } from "./commentDialog.vue?vue&type=template&id=f0a67d00&scoped=true&"
import script from "./commentDialog.vue?vue&type=script&lang=js&"
export * from "./commentDialog.vue?vue&type=script&lang=js&"
import style0 from "./commentDialog.vue?vue&type=style&index=0&id=f0a67d00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a67d00",
  null
  
)

export default component.exports